import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../../../utils/propUtils';
import VeltCommentDialogSuggestionAgentAvatarWireframe from './VeltCommentDialogSuggestionAgentAvatarWireframe/VeltCommentDialogSuggestionAgentAvatarWireframe';
import VeltCommentDialogSuggestionAgentNameWireframe from './VeltCommentDialogSuggestionAgentNameWireframe/VeltCommentDialogSuggestionAgentNameWireframe';
var VeltCommentDialogSuggestionAgentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-agent-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionAgentWireframe.Avatar = VeltCommentDialogSuggestionAgentAvatarWireframe;
VeltCommentDialogSuggestionAgentWireframe.Name = VeltCommentDialogSuggestionAgentNameWireframe;
export default VeltCommentDialogSuggestionAgentWireframe;
